import { Injectable } from '@angular/core';
import {CanActivate,Router} from '@angular/router';
import { CommonService } from '../app/common.service';


@Injectable({
  providedIn: 'root'
})
export class ProductGuard implements CanActivate {
  constructor(private router: Router,private commonService: CommonService){}
  canActivate(): boolean{
    if(this.commonService.Restrictmodule()){
      this.router.navigate(['/login'])
      return false;
   }else{
     return true;
   }
 }
}
